<app-footer-garage-user-desktop *ngIf="!isMobile"></app-footer-garage-user-desktop>
<app-footer-garage-user-mobile *ngIf="isMobile"></app-footer-garage-user-mobile>
